import { FC } from "react";
import styles from "./Footer.module.scss";
import classNames from "classnames";

interface FooterProps {
  classess?: string;
}

const Footer: FC<FooterProps> = ({ classess }) => {
  return (
    <footer className={classNames(styles.Footer, {}, [classess])}>
      <div className={styles.text} style={{ paddingRight: 15 }}>
        Наш адресс: г.Ревда ул.Максима Горького 2
      </div>
      <div className={styles.text} style={{ paddingLeft: 15 }}>
        © 2025 Стоматологический кабинет «Денталика»
      </div>
    </footer>
  );
};

export default Footer;
